export const MAX_RETAINED_WIDGET_WORKSPACES = 3;

export function retainWidgetWorkspace(retainedWorkspaceIds, workspaceId, limit = MAX_RETAINED_WIDGET_WORKSPACES) {
  if (!workspaceId) return retainedWorkspaceIds;

  const normalizedWorkspaceId = String(workspaceId);
  const normalizedLimit = Math.max(1, Number(limit) || MAX_RETAINED_WIDGET_WORKSPACES);
  const nextWorkspaceIds = retainedWorkspaceIds
    .map(String)
    .filter((retainedWorkspaceId) => retainedWorkspaceId !== normalizedWorkspaceId);

  nextWorkspaceIds.push(normalizedWorkspaceId);
  return nextWorkspaceIds.slice(-normalizedLimit);
}

export function pruneWidgetWorkspaces(retainedWorkspaceIds, availableWorkspaceIds, activeWorkspaceId) {
  const normalizedActiveWorkspaceId = activeWorkspaceId ? String(activeWorkspaceId) : null;
  const normalizedAvailableWorkspaceIds = new Set([...availableWorkspaceIds].map(String));

  return retainedWorkspaceIds.filter(
    (retainedWorkspaceId) =>
      String(retainedWorkspaceId) === normalizedActiveWorkspaceId || normalizedAvailableWorkspaceIds.has(String(retainedWorkspaceId)),
  );
}

export function pruneDirectMessageIdsByWorkspace(directMessageIdsByWorkspace, retainedWorkspaceIds) {
  const retainedWorkspaceIdSet = new Set(retainedWorkspaceIds.map(String));
  const retainedEntries = Object.entries(directMessageIdsByWorkspace).filter(([workspaceId]) =>
    retainedWorkspaceIdSet.has(String(workspaceId)),
  );

  return retainedEntries.length === Object.keys(directMessageIdsByWorkspace).length
    ? directMessageIdsByWorkspace
    : Object.fromEntries(retainedEntries);
}

export function stableWidgetWorkspaceRenderOrder(mountedWorkspaceIds, retainedWorkspaceIds) {
  const retainedIds = [...new Set(retainedWorkspaceIds.map(String))];
  const retainedIdSet = new Set(retainedIds);
  const nextMountedIds = [...new Set(mountedWorkspaceIds.map(String))].filter((workspaceId) =>
    retainedIdSet.has(workspaceId),
  );
  const mountedIdSet = new Set(nextMountedIds);

  for (const workspaceId of retainedIds) {
    if (mountedIdSet.has(workspaceId)) continue;

    nextMountedIds.push(workspaceId);
    mountedIdSet.add(workspaceId);
  }

  return nextMountedIds;
}
